import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div.attrs({
  className: 'fixed-container'
})`
`

export default class FixedContainer extends Component {
  render () {
    return (
      <Container>
        {this.props.children}
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FixedWrapper/index.js